// extracted by mini-css-extract-plugin
module.exports = {"disabled":"style-module_disabled__aTfFUW_aMbS4P_8NVOfc"};